import * as React from 'react';
const SvgOmnichannel = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M25.229 62H38.06a7.673 7.673 0 0 1-2.143-4.935c-.223-4.282 3.3-8.051 7.591-8.114a7.712 7.712 0 0 1 7.819 7.707 7.672 7.672 0 0 1-2.153 5.337h12.831V49.164a7.68 7.68 0 0 0 5.337 2.153 7.706 7.706 0 0 0 7.707-7.819c-.058-4.287-3.827-7.814-8.114-7.591A7.685 7.685 0 0 0 62 38.05V25.22H32.97"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62 25.229V38.06a7.673 7.673 0 0 1 4.935-2.143c4.282-.223 8.051 3.3 8.114 7.59.058 4.307-3.416 7.82-7.708 7.82a7.673 7.673 0 0 1-5.336-2.153v12.83h12.831a7.68 7.68 0 0 0-2.153 5.337 7.706 7.706 0 0 0 7.819 7.708c4.287-.058 7.814-3.827 7.591-8.114A7.71 7.71 0 0 0 85.95 62h12.83V32.97"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.771 62H85.94a7.674 7.674 0 0 1 2.143 4.935c.223 4.282-3.3 8.051-7.591 8.114a7.71 7.71 0 0 1-7.819-7.708c0-2.075.823-3.952 2.153-5.336h-12.83v12.831a7.68 7.68 0 0 0-5.338-2.153 7.706 7.706 0 0 0-7.707 7.819c.058 4.287 3.827 7.814 8.114 7.591A7.685 7.685 0 0 0 62 85.95v12.83h29.03"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62 98.771V85.94a7.674 7.674 0 0 1-4.935 2.143c-4.282.223-8.05-3.3-8.114-7.591a7.712 7.712 0 0 1 7.708-7.819c2.075 0 3.953.823 5.336 2.153v-12.83h-12.83a7.68 7.68 0 0 0 2.152-5.338 7.706 7.706 0 0 0-7.819-7.707c-4.286.058-7.813 3.827-7.59 8.114A7.684 7.684 0 0 0 38.05 62H25.22v29.03M98.771 54.259l14.849-15.502a21.187 21.187 0 0 0 5.119-8.284l2.893-8.675c.073-.222.198-.425.368-.59M103.687 2.005c-.169.17-.377.285-.61.339L91.63 4.985a7.564 7.564 0 0 0-3.648 2.023L73.448 21.542a2.158 2.158 0 0 0 0 3.058s5.97 4.5 11.81 0l7.703-7.113c1.732 1.733 7.741 3.871 11.611 0M54.259 25.229 38.757 10.38a21.187 21.187 0 0 0-8.284-5.119l-8.675-2.893a1.45 1.45 0 0 1-.59-.368M2.005 20.313c.17.17.285.378.339.61L4.985 32.37a7.563 7.563 0 0 0 2.023 3.648l14.534 14.535a2.158 2.158 0 0 0 3.058 0s4.5-5.97 0-11.81l-7.113-7.703c1.733-1.732 3.871-7.742 0-11.612M69.741 98.771l15.502 14.849a21.187 21.187 0 0 0 8.283 5.119l8.675 2.893c.223.073.426.199.591.368M121.995 103.687a1.248 1.248 0 0 1-.338-.61l-2.642-11.447a7.566 7.566 0 0 0-2.023-3.648l-14.534-14.534a2.158 2.158 0 0 0-3.058 0s-4.5 5.97 0 11.81l7.113 7.703c-1.733 1.732-3.871 7.741 0 11.611"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.229 69.741 10.38 85.243a21.187 21.187 0 0 0-5.119 8.283l-2.893 8.675a1.453 1.453 0 0 1-.368.591M20.313 121.995c.17-.169.378-.285.61-.338l11.447-2.642a7.566 7.566 0 0 0 3.648-2.023l14.535-14.534a2.158 2.158 0 0 0 0-3.058s-5.97-4.5-11.81 0l-7.703 7.113c-1.732-1.733-7.742-3.871-11.612 0"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgOmnichannel;
